import English from './en';
import * as Languages from '@Config/languages';

class LanguageManager
{
    private language: string

    private languages: {
        [key: string]: any
    }

    /**
     * Constructor
     */
    constructor()
    {
        this.language = Languages.ENGLISH;

        this.languages = {
            [Languages.ENGLISH]: English
        };
    }

    /**
     * Gets the language key
     * @param key
     */
    public getLanguage(key: string): string
    {
        key = key.toLowerCase();

        let language = '';

        const languages = this.languages;

        if (typeof languages[this.language][key] === 'undefined')
        {
            throw new Error(`Language key ${key} not found`);
        }
        else
        {
            language = languages[this.language][key];
        }

        return language;
    }

    /**
     * Sets language
     * @param language
     */
    public setLanguage(language: string)
    {
        if (typeof this.languages[language] === 'undefined')
        {
            throw new Error(`Language ${language} not found`);
        }

        this.language = language;
    }
}

export default new LanguageManager();
